<div class="container-view">
  <div #containerFilter class="container-filter">
    <results-filters-box
      *ngIf="resultFilters()"
      #filtersBox
      [separateLayout]="false"
      [filters]="resultFilters()"
      (filterChange)="onFilterChange($event)"
    ></results-filters-box>
  </div>
  @if (!isLoading && displayedContext?.items.length > 0) {
    <search-results-list
      [showSearchResults]="false"
      [displayedContext]="displayedContext"
      [items]="displayedContext.items"
      [isOwner]="false"
      [smallView]="true"
      [maxColumnsInScreen]="true"
      [removeFocus]="true"
      [listView]="{ isEditable: false, isDraggable: false }"
      [listName]="'recently_viewed'"
      [displayBg]="false"
      (recentSearchItemClicked)="recentSearchClicked($event)"
    ></search-results-list>
  }
</div>
